import {useFormikContext} from 'formik'
import {useEffect} from 'react'

// Đồng bộ trạng thái loading THẬT của 1 async action (isLoading từ useAsyncAction) vào
// isSubmitting của Formik. Formik chỉ tự tắt isSubmitting nếu onSubmit trả về Promise -
// khi onSubmit chỉ dispatch redux-saga (đồng bộ, không trả Promise) thì phải tự tắt, nếu
// không nút Lưu sẽ loading vĩnh viễn MỘT KHI form không unmount ngay sau submit (form
// render inline/tab, không phải modal tự đóng bằng onCancel() sau submit).
//
// Cách dùng: thả component này vào bên trong <Formik>, truyền isSubmitting = isLoading
// của useAsyncAction tương ứng với onSubmit của form đó.
//
//   const {handleAsyncAction: onUpdate, isLoading: isUpdating} = useAsyncAction({...})
//   <Formik onSubmit={(values) => onUpdate(values, {id})}>
//       <SyncFormikSubmitting isSubmitting={isUpdating}/>
//       ...
//   </Formik>
//
// Xem docs/coding-style/conventions.md — "Known pitfall — nút Lưu loading vĩnh viễn".
export const SyncFormikSubmitting = ({isSubmitting}) => {
    const {isSubmitting: formikIsSubmitting, setSubmitting} = useFormikContext()
    useEffect(() => {
        if (!isSubmitting && formikIsSubmitting) {
            setSubmitting(false)
        }
    }, [isSubmitting, formikIsSubmitting, setSubmitting])
    return null
}

export default SyncFormikSubmitting
